import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverviewListComponent } from './overview-list/overview-list.component';
import {EbcontGalaxyModule} from '@ebcont/ebcont.galaxy.js';
import { GeneralModule } from "@modules/general/general.module";
import {TeamModule} from "@modules/team/team.module";
import { NgxTranslateModule } from "@modules/translate/translate.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { LeafletMapComponent } from "./leaflet-map/leaflet-map.component";




@NgModule({
  declarations: [OverviewListComponent
  ],
  schemas: [],
  exports: [OverviewListComponent],
  imports: [CommonModule, EbcontGalaxyModule, GeneralModule, TeamModule, NgxTranslateModule, FontAwesomeModule, LeafletMapComponent]
})
export class OverviewModule {

}
